import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const CAMPRegistrationAdminReport = () => {
    const [campData, setCampData] = useState([]);
    const tableRef = useRef(null)

    // Fetch Camp Records
  useEffect(() => {
    const fetchCampData = async () => {
      try {
        const token = localStorage.getItem("authToken");
          const response = await fetch(`${API_BASE_URL}/CampRegistration/CampRegistrationReport`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error("Failed to fetch camp records");

        let data = await response.json();

        // Add SrNo to each record
        data = data.map((record, index) => ({
          ...record,
          SrNo: index + 1,
        }));

        setCampData(data);
      } catch (error) {
        console.error("Error fetching camp data:", error);
      }
    };

    fetchCampData();
  }, []);

  // Handle Status Update
  const handleStatusChange = async (registrationNo, newStatus) => {
    const comment = prompt("Enter comment for this status change:");
    if (comment === null) return; // User cancelled

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${API_BASE_URL}/CampRegistration/updateStatus/${registrationNo}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status: newStatus, comment }),
      });

      if (!response.ok) throw new Error("Failed to update status");

      // Update local state
      setCampData((prev) =>
        prev.map((row) =>
          row.registrationNo === registrationNo
            ? { ...row, status: newStatus, comment }
            : row
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
    
// Initialize DataTable
  useEffect(() => {
    if (tableRef.current && campData.length > 0) {
      const table = $(tableRef.current).DataTable({
        destroy: true,
        data: campData,
        columns: [
          { data: "SrNo", title: "Sr No" },
          { data: "startDate", title: "Date" },
          { data: "name", title: "Organizer Name" },
          { data: "organizerContactNo", title: "Organizer Contact" },
          { data: "registrationNo", title: "Registration No" },
          {
            data: "status",
            title: "Status",
            render: function (data, type, row) {
              return `
                <select class="form-control status-dropdown" data-id="${row.registrationNo}">
                  <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                  <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                  <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                  <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                </select>
              `;
            },
          },
          { data: "comment", title: "Comment" },
          {
            data: null,
            title: "Submitted Form",
            render: function (data, type, row) {
              return `<button class='btn btn-sm btn-info download-btn' data-id='${row.registrationNo}'>Download PDF</button>`;
            },
          },
        ],
      });

      // Handle download button click
        $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
          const registrationNo = $(this).data("id");
          downloadPDF(registrationNo);
        });

      // Bind Status Dropdown Change
      $(tableRef.current).on("change", ".status-dropdown", function () {
        const registrationNo = $(this).attr("data-id");
        const newStatus = $(this).val();
        handleStatusChange(registrationNo, newStatus);
      });

      // Cleanup
      return () => {
        table.destroy();
        $(tableRef.current).off("change", ".status-dropdown");
      };
    }
  }, [campData]);

  const downloadPDF = async (registrationNo) => {
  try {
      const authToken = localStorage.getItem("authToken");

      const response = await fetch(
        `${API_BASE_URL}/CampRegistration/DownloadPdf/${registrationNo}`,
          {
              method: "GET",
              headers: {
                  Authorization: `Bearer ${authToken}`,
              },
          }
      );

      if (!response.ok) {
          throw new Error(`Failed to download file: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Camp_Report_${registrationNo}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
  } catch (error) {
      console.error("Download error:", error);
  }
};


  return (
    <>
         <table ref={tableRef} id="productsTable" className="table table-bordered table-hover table-product" style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Date</th>
            <th>Name</th>
            <th>Organizer Contact</th>
            <th>Registration No</th>
            <th>Status</th>
            <th>Comment</th>
            {/* <th>Acknowledgement Receipt</th> */}
            <th>Submitted Form</th>
          </tr>
        </thead>
    
      </table>
      </>
  );
}

export default CAMPRegistrationAdminReport;



// import React, { useEffect, useRef } from 'react';
// import $ from 'jquery';
// import 'datatables.net-bs4';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
// import 'bootstrap/dist/css/bootstrap.min.css';


// const CAMPRegistrationReportData = [
//   { SrNo: 1, Date: "2011/04/25", name: "Tiger", AcknowledgementReceipt:"btn", SubmittedForm: "btn"},
//   { SrNo: 2, Date: "2011/07/25", name: "Garrett", AcknowledgementReceipt: "btn", SubmittedForm: "btn"},
//   { SrNo: 3, Date: "2011/04/25", name: "Nixon", AcknowledgementReceipt: "btn", SubmittedForm: "btn"},
//   { SrNo: 4, Date: "2011/07/25", name: "Winters", AcknowledgementReceipt: "btn", SubmittedForm: "btn"},
//   // ... add more data as needed
// ]

// const CAMPRegistrationAdminReport = () => {
//   const tableRef = useRef(null)
//   useEffect(() => {
//     if (tableRef.current) {
//       const table = $(tableRef.current).DataTable({
//         data: CAMPRegistrationReportData,
//         columns: [
//           { data: 'SrNo', title: 'Sr No' },
//           { data: 'Date', title: 'Date' },
//           { data: 'name', title: 'Name' },
//           { data: 'AcknowledgementReceipt', title: 'Receipt',  render: (data, type, row) => {
//             return `

//             <button class="btn" data-id="${row.srNo}">
//                   Download  <i class="mdi mdi-download"></i>
//               </button>
        
//             `;
//           } 
//         },
//         { data: 'SubmittedForm', title: 'Submitted Form',  render: (data, type, row) => {
//           return `

//            <button class="btn" data-id="${row.srNo}">
//                   Download  <i class="mdi mdi-download"></i>
//               </button>
           
//           `;
//         } 
//       }
//         ],
//         initComplete: function () {
//           this.api().columns().each(function () {
//             const column = this
//             const select = $('<select className="form-control"><option value=""></option></select>')
//               .appendTo($(column.footer()).empty())
//               .on('change', function () {
//                 const val = $.fn.dataTable.util.escapeRegex(
//                   $(this).val()
//                 )

//                 column
//                   .search(val ? '^' + val + '$' : '', true, false)
//                   .draw()
//               })

//             column.data().unique().sort().each(function (d, j) {
//               select.append('<option value="' + d + '">' + d + '</option>')
//             })
//           })
//         }
//       })

//       return () => {
//         table.destroy()
//       }
//     }
//   }, [])

//   return (
//     <>
//          <table ref={tableRef} id="productsTable" className="table table-bordered table-hover table-product" style={{ width: '100%' }}>
//         <thead>
//           <tr>
//             <th>Sr No</th>
//             <th>Date</th>
//             <th>Name</th>
//             <th>Acknowledgement Receipt</th>
//             <th>Submitted Form</th>
//           </tr>
//         </thead>
    
//       </table>
//       </>
//   );
// }

// export default CAMPRegistrationAdminReport;